export const REQUEST_CREATE_EVERSIGN_DOCUMENT =
	"REQUEST_CREATE_EVERSIGN_DOCUMENT";
export const RECEIVE_CREATE_EVERSIGN_DOCUMENT =
	"RECEIVE_CREATE_EVERSIGN_DOCUMENT";
export const REQUEST_GET_EVERSIGN_DATA =
	"REQUEST_GET_EVERSIGN_DATA";
export const RECEIVE_GET_EVERSIGN_DATA =
	"RECEIVE_GET_EVERSIGN_DATA";